import './Toggle.css'
import React from 'react'
import RawToggle from 'react-toggle'
import classNames from 'classnames'

export default function Toggle({
  labels = undefined,
  className = undefined,
  small = false,
  ...props
}) {
  const icons = labels ? labels : null
  const _className = classNames(className, {
    'react-toggle--labelled': Boolean(labels),
    small: Boolean(small),
  })

  return <RawToggle className={_className} icons={icons} {...props} />
}
